import VueGtag from 'vue-gtag'
import Vue from 'vue'

export default function initGtag (configEmpresa) {
  const idGtag = configEmpresa.idGtag

  if (idGtag) {
    Vue.use(VueGtag, { config: { id: idGtag } })
  }
}
